import React from "react";

import { ReactComponent as IconUser } from "../../../../assets/images/AnswerList/icon_user.svg";
import OneAnswerBox from "../OneAnswerBox";
import { OnePagePortfolioAssessmentQuestionAnswers } from "../../../../state";

import styles from "./AnswerBox.module.scss";

type AnswerBoxProps = {
  nameOpened: boolean;
  classFullName?: string;
  index?: number;
  studentFullName: string;
  studentNoInSchool: string;
  studentAnswers: OnePagePortfolioAssessmentQuestionAnswers[];
  isHighlighted?: boolean;
};

const AnswerBox = React.forwardRef<HTMLDivElement, AnswerBoxProps>(
  (
    {
      nameOpened,
      classFullName,
      index,
      studentFullName,
      studentNoInSchool,
      studentAnswers,
      isHighlighted,
    },
    ref,
  ) => {
    const className = classFullName ? `${classFullName} ` : "";

    return (
      <div className={styles.answer} ref={ref}>
        <p className={styles.name}>
          <IconUser />
          {nameOpened ? (
            <>
              <span>{studentFullName}</span>
              <span>{studentNoInSchool}</span>
            </>
          ) : (
            `${className}回答${index}`
          )}
        </p>
        <OneAnswerBox
          questionAnswers={studentAnswers}
          isHighlighted={isHighlighted}
        />
      </div>
    );
  },
);

export default AnswerBox;
